import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
} from '@heroicons/react/24/outline';
import { Button } from '../Button';

export function FormActionsFooter<T>({
  onCancel,
  onContinue,
  onGoBack,
  onSaveDraft,
  onSubmit,
  submitText = 'Save and Submit',
  cancelText = 'Cancel',
  continueText = 'Continue',
  goBackText = 'Go Back',
  currentStep,
  stepsLength,
  isSubmitting = false,
  isSavingDraft = false,
  customActions,
  canSubmit = true,
}: {
  onCancel: () => void;
  onContinue?: () => void | Promise<void>;
  onGoBack?: () => void;
  onSaveDraft?: () => void;
  onSubmit?: () => void;
  submitText?: string;
  cancelText?: string;
  continueText?: string;
  goBackText?: string;
  currentStep: number;
  stepsLength: number;
  isSubmitting?: boolean;
  isSavingDraft?: boolean;
  customActions?: React.ReactNode;
  canSubmit?: boolean;
}) {
  return (
    <div className='flex justify-between items-center px-10 py-2 bg-blue-100 sticky bottom-0 left-0 right-0 z-50'>
      <Button
        label={cancelText}
        onClick={onCancel}
        intent='tertiary'
        size='sm'
        type='button'
      />
      <div className='flex gap-2'>
        {customActions}
        {onSaveDraft && (
          <Button
            label={isSavingDraft ? 'Saving Draft...' : 'Save as Draft'}
            onClick={onSaveDraft}
            intent='secondary'
            size='sm'
            type='button'
            disabled={isSavingDraft || isSubmitting}
          />
        )}
        {currentStep > 1 && onGoBack && (
          <Button
            label={goBackText}
            startIcon={<ArrowLeftCircleIcon className='w-5 h-5' />}
            onClick={onGoBack}
            intent='primary'
            size='sm'
            disabled={isSubmitting || isSavingDraft}
            type='button'
          />
        )}
        {currentStep < stepsLength && (
          <Button
            label={continueText}
            endIcon={<ArrowRightCircleIcon className='w-5 h-5 ml-1' />}
            onClick={onContinue}
            intent='primary'
            size='sm'
            type='button'
          />
        )}
        {currentStep === stepsLength && (
          <Button
            label={submitText}
            type={onSubmit ? 'button' : 'submit'}
            onClick={onSubmit}
            intent='primary'
            size='sm'
            disabled={isSubmitting || isSavingDraft || !canSubmit}
          />
        )}
      </div>
    </div>
  );
}
